<template>
  <div class="results-content-block">
    <not-found v-if="hotels.length === 0 && !searching && !appending">
      <vb-button
        class="not-found__cta"
        v-if="filters_length > 0"
        :vb_options="{
          text: 'Rimuovi tutti i filtri e riprova',
          variant: 'outline-info',
          size: 'sm',
        }"
        @click="reset_filters"
      />
    </not-found>
    <dynamic-scroller
      page-mode
      ref="results-scroller"
      :items="items"
      :item-size="null"
      :min-item-size="100"
      key-field="id"
    >
      <template v-slot="{ item, index, active }">
        <dynamic-scroller-item
          class="pb-4"
          :item="item"
          :data-index="index"
          :active="active">
          <component v-if="item.component" :is="item.component" v-bind="item.props" />
          <pad v-else :hotel="item" @toggle-map="toggle_map(item)" :nights="nights" />
        </dynamic-scroller-item>
      </template>
    </dynamic-scroller>
  </div>
</template>

<script>
import NotFound from "@/components/blocks/not-found";
import MarketingPad from "@/components/blocks/marketing-pad.vue";
import Pad from "@bookingv3/components/blocks/pad.vue";
import PadSeparator from "@bookingv3/components/blocks/pad-separator.vue";
import { add_extra_components_to_results, decode_parameters } from "@/utilities";

export default {
  name: "results-content-block",

  components: {
    "not-found": NotFound,
    "marketing-pad": MarketingPad,
    "pad-separator": PadSeparator,
    pad: Pad,
  },

  props: {
    hotels: {
      type: Array,
      default: () => {
        return [];
      },
    },
    searching: Boolean,
    appending: Boolean,
    filters_length: Number,
    nights: Number,
    location: Object,
    current_search: String,
  },

  data() {
    return {
      last_search_location: '',
      hotels_with_location_separator: [],
    };
  },
  computed: {
    items() {
      return this.add_extra_components_to_results(this.hotels_with_location_separator, "id");
    },
  },

  created() {},

  mounted() {
    this.last_search_location = decode_parameters(this.current_search).suggestion

    let hotels_with_location_separator = [],
    has_separator_for_current_location = false;
    this.hotels.forEach(hotel => {
      if (!has_separator_for_current_location && hotel.accommodations_details.city !== this.last_search_location.name) {
        hotels_with_location_separator.push({
          id: `separator-${0}`,
          component: 'pad-separator',
        });
        has_separator_for_current_location = true;
      }
      hotels_with_location_separator.push(hotel);
    });
    this.hotels_with_location_separator = hotels_with_location_separator;
  },

  methods: {
    add_extra_components_to_results, 
    reset_filters() {
      this.$emit("reset-filters");
    },
    toggle_map(payload) {
      this.$emit("toggle-map", payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.results-content-block {
  &__not-found {
    border-radius: 10px;
    background-color: #fafcff;
    padding: 20px 30px;
    display: flex;
  }
}
</style>
